<ngx-l2-minimal-menu-bar>
  <ngx-heka-no-app-access
    class="mx-auto"
    [title]="'OAUTH.NO_ACCESS.TITLE' | translate"
    [description]="description()">

    <button color="primary" mat-flat-button (click)="goToMHP()">
      {{ 'OAUTH.NO_ACCESS.BACK_TO_DASHBOARD' | translate }}
    </button>
  </ngx-heka-no-app-access>
</ngx-l2-minimal-menu-bar>